var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 4.6875V0H58.0403L1.2 37.8936L3.80016 41.7938L9.53125 37.9731V60.9375H0V80H80V18.75H70.4688V4.6875H80ZM37.6562 32.8125V46.875H32.9688V22.3481L47.0312 12.9731V32.8125H37.6562ZM14.2188 34.8481L28.2812 25.4731V46.875H18.9062V60.9375H14.2188V34.8481ZM75.3125 75.3125H4.6875V65.625H23.5938V51.5625H42.3438V37.5H61.0938V23.4375H75.3125V75.3125ZM65.7812 18.75H56.4062V32.8125H51.7188V9.84813L59.4597 4.6875H65.7812V18.75Z",
    fill: "#C49A36"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility5);
export default __webpack_public_path__ + "static/media/gefion-facility-5.460d4b5f.svg";
export { ForwardRef as ReactComponent };